import { useNavigate, useParams, Navigate } from 'react-router-dom';
import { DashboardLayout } from '@/layout/DashboardLayout';
import { SettingsContent } from './components/SettingsContent';
import {
  SettingsSidebar,
  SETTINGS_SECTIONS,
  type SettingsSectionId,
} from './components/SettingsSidebar';

const SECTION_IDS = SETTINGS_SECTIONS.map((s) => s.id);

export function SettingsPage() {
  const { sectionId } = useParams<{ sectionId: string }>();
  const navigate = useNavigate();
  if (sectionId === 'whatsapp-pricing') return <Navigate to="/settings/channels?tab=pricing" replace />;
  if (sectionId === 'resend') return <Navigate to="/settings/integrations" replace />;

  if (sectionId === 'meta' || sectionId === 'meta-channels' || sectionId === 'servidores-uazapi') {
    return <Navigate to={sectionId === 'servidores-uazapi' ? '/settings/channels?tab=uazapi' : '/settings/channels'} replace />;
  }
  if (sectionId === 'gateways') return <Navigate to="/settings/financial?tab=gateways" replace />;
  if (sectionId === 'branding' || sectionId === 'platform') {
    return <Navigate to={sectionId === 'branding' ? '/settings/general?tab=appearance' : '/settings/general'} replace />;
  }
  if (!sectionId || !SECTION_IDS.includes(sectionId as SettingsSectionId)) {
    return <Navigate to="/settings/general" replace />;
  }
  const activeSection = sectionId as SettingsSectionId;

  const handleSectionChange = (id: SettingsSectionId) => {
    navigate(`/settings/${id}`, { replace: true });
  };

  return (
    <DashboardLayout title="Configurações" noContentPadding>
      <div className="flex h-[calc(100vh-64px)] min-h-0 overflow-hidden">
        <SettingsSidebar activeSection={activeSection} onSectionChange={handleSectionChange} />
        <div className="flex flex-1 flex-col overflow-hidden bg-gray-50">
          <main className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
            <div className="p-6">
              <SettingsContent activeSection={activeSection} />
            </div>
          </main>
        </div>
      </div>
    </DashboardLayout>
  );
}
